.CookingModal {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.CookingModal .FeedSection {
  padding: 0.5em;
  text-align: center;
  line-height: 1em;
}
.CookingModal .FeedSection button {
  font: inherit;
}
.CookingModal .FeedSection button:not([isEnabled]) {
  opacity: 0.5;
}
.CookingModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.CookingModal .UnitsSection .Unit {
  width: 1em;
  font-size: 1.5em;
  margin: 0em 0.2em;
}
.CookingModal .UnitsSection .Unit .Sprite {
  width: 1em;
  height: 1em;
  position: relative;
}
.CookingModal .UnitsSection .Unit .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.CookingModal .UnitsSection .Unit .Description {
  font-size: 0.15em;
  text-align: center;
}
.CookingModal .UnitsSection .Unit .Description .Name {
  font-size: 1.25em;
}
.CookingModal .UnitsSection .Unit .Description .Status[color=red] {
  color: #d54b33;
}
.CookingModal .UnitsSection .Unit button:not([isEnabled]) {
  opacity: 0.5;
}
.CookingModal .FoodsSection {
  flex: 1;
  padding: 0.5em;
  text-align: center;
}
.CookingModal .DoneSection {
  padding: 0.5em;
  text-align: center;
}
.CookingModal .DoneSection button {
  font: inherit;
  font-size: 0.75em;
  padding: 0em 1em;
}
